import {
    type ApiResult,
    type BaseParams,
    type CreatePromoCode,
    type PostParams,
    type PromoCodeId,
    type PromoCodesResponse,
} from '@app/client';

import { Request } from '../../common';
import { links } from '../../links';

export async function getPromoCodes(params: BaseParams): Promise<ApiResult<PromoCodesResponse>> {
    return Request.getRequest<PromoCodesResponse>({
        ...params,
        target: links.codes().collection(),
    });
}

export async function createPromoCode(
    params: BaseParams & PostParams<CreatePromoCode>,
): Promise<ApiResult<PromoCodesResponse>> {
    return Request.postRequest<PromoCodesResponse>({
        ...params,
        target: links.codes().collection(),
    });
}

export async function deletePromoCode(
    params: BaseParams & { id: PromoCodeId },
): Promise<ApiResult<PromoCodesResponse>> {
    return Request.deleteRequest<never>({
        ...params,
        target: links.codes().single(params.id),
    });
}
